<template>
  <div>
    <input
      ref="input"
      :value="shownValue"
      @focus="focus"
      @blur="blur"
      @input="updateValue()"
      @change="change"
      :placeholder="placeholder"
      :name="name"
      :disabled="masked"
    />
  </div>
</template>

<script>
export default {
  name: 'MaskableInput',

  props: {
    value: {
      type: String,
      default: null,
    },
    masked: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      manualUpdate: false,
      shownValue: null,
    };
  },

  watch: {
    value: function (value) {
      if (this.manualUpdate === false) {
        this.formatValue(value);
      }
    },
  },

  mounted() {
    this.shownValue =
      this.masked === false ? this.value : this.format(this.value);
  },

  methods: {
    updateValue() {
      this.$emit('input', this.$refs.input.value);
      this.manualUpdate = true;
    },
    focus() {
      this.shownValue = this.value;
      this.manualUpdate = false;
    },
    blur() {
      this.shownValue = this.value;
      this.manualUpdate = false;
    },
    formatValue(value) {
      this.shownValue = this.masked === true ? this.format(value) : value;
    },
    format(value) {
      return value
        ? value.replace(
            /([a-zA-ZåäöÅÄÖ0-9-.,]{1})([a-zA-ZåäöÅÄÖ0-9-.,]*)([a-zA-ZåäöÅÄÖ0-9-.,]{1})/g,
            function (match, p1, p2, p3) {
              return p1 + '*'.repeat(p2.length) + p3;
            },
          )
        : null;
    },
    change() {
      this.$parent.checkValidation(this.name);
    },
  },
};
</script>
